<template>
	<div class="register-form-part">
		<p>注册账号</p>
		<el-form :model="registerForm" :rules="rules" ref="registerForm" class="register-form">
			<el-form-item prop="username">
				<input type="password" hidden autocomplete="new-password">
				<div class="register-item">
					<i class="register-icon" :class="userFocus ? 'userFocus' : 'userBlur'"/>
					<el-input
						v-model="registerForm.username"
						placeholder="请输入手机号"
						class="register-input"
						@focus="userHandle(true)"
						@blur="userHandle(false)"
						:clearable="true"
						@keyup.enter.native="onKeyupInput"
					></el-input>
				</div>
			</el-form-item>
			<el-form-item prop="password">
				<div class="register-item">
					<i class="register-icon" :class="pwdFocus ? 'pwdFocus' : 'pwdBlur'"/>
					<el-input
						v-model="registerForm.password"
						placeholder="请设置密码(6-20位字母数字组合)"
						class="register-input"
						@focus="pwdHandle(true)"
						@blur="pwdHandle(false)"
						:type="pwdShow ? 'text' : 'password'"
						:clearable="true"
						:minlength="6"
						:maxlength="20"
						@keyup.enter.native="onKeyupInput"
					></el-input>
					<i class="register-icon" :class="pwdShow ? 'pwdShow' : 'pwdHidden'" @click="pwdShowHandle"></i>
				</div>
			</el-form-item>
			<el-form-item prop="confirmPwd">
				<div class="register-item">
					<i class="register-icon" :class="confirmPwdFocus ? 'pwdFocus' : 'pwdBlur'"/>
					<el-input
						v-model="registerForm.confirmPwd"
						placeholder="请确认密码"
						class="register-input"
						@focus="confirmPwdHandle(true)"
						@blur="confirmPwdHandle(false)"
						:type="confirmPwdShow ? 'text' : 'password'"
						:clearable="true"
						@keyup.enter.native="onKeyupInput"
					></el-input>
					<i class="register-icon" :class="confirmPwdShow ? 'pwdShow' : 'pwdHidden'" @click="confirmPwdShowHandle"></i>
				</div>
			</el-form-item>
			<el-form-item prop="verificationCode">
				<div class="register-item">
					<i class="register-icon" :class="verificationCodeFocus ? 'verifyFocus' : 'verifyBlur'"/>
					<el-input
						v-model="registerForm.verificationCode"
						placeholder="请输入验证码"
						class="register-input verify-input"
						@focus="verifyHandle(true)"
						@blur="verifyHandle(false)"
						:clearable="true"
					></el-input>
					<el-button type="primary" size="small" @click="getVerificationCode" :disabled="registerBool" v-if="!verifyTimeShow">获取验证码</el-button>
					<el-button type="primary" size="small" class="verify-time-button" v-else>{{verifyTime}}s</el-button>
				</div>
			</el-form-item>
			<el-button type="primary" class="register-button" @click="register">立即注册</el-button>
			<div class="agreement-box">
				<div class="agreement">
					<el-checkbox v-model="checked">
					</el-checkbox>
					<span @click="goAgreement" class="agreement">我同意极速订平台服务协议</span>
				</div>
				<div class="toLogin" @click="toLogin">
					去登录>
				</div>
			</div>
		</el-form>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { inputAutoFocus } from '@/js/lib/form'
export default {
	name: 'registerForm',
	data () {
		return {
			userFocus: false,
			pwdFocus: false,
			pwdShow: false,
			confirmPwdFocus: false,
			confirmPwdShow: false,
			verificationCodeFocus: false,
			checked: false,
			verifyTime: 60,
			verifyTimeShow: false,
			repeatUsername: false,
			phoneReg: /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/,
			passwordReg: /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)]|[\(\)])+$)([^(0-9a-zA-Z)]|[\(\)]|[a-z]|[A-Z]|[0-9]){6,}$/,
			chinessReg: /^[\s\S]*[\u4E00-\u9FFF]+[\s\S]*$/,
			registerForm: {
				username: '',
				password: '',
				confirmPwd: '',
				verificationCode: ''
			},
			rules: {
				username: [
					{ required: true, message: '请输入正确的手机号码', trigger: 'blur' }
				],
				password: [
					{ required: true, message: '请输入密码', trigger: 'blur' }
				],
				confirmPwd: [
					{ required: true, message: '请确认密码', trigger: 'blur' },
					{
						validator: (rule, value, callback) => {
							if (value === '') {
								callback(new Error('请再次输入密码'))
							} else if (value !== this.registerForm.password) {
								callback(new Error('密码与确认密码不一致，请修改确认密码！'))
							} else {
								callback()
							}
						},
						trigger: 'blur'
					}
				],
				verificationCode: [
					{ required: true, message: '请输入验证码', trigger: 'blur' }
				]
			}
		}
	},
	computed: {
		...mapState({
			platFormName: state => state.platFormStore.platFormName
		}),
		registerBool () {
			if (this.registerForm.username && this.registerForm.username.length === 11) {
				return false
			} else {
				return true
			}
		}
	},
	created () {
		if (!this.$fxUtils.isEmptyObjSHW(this.$route.query)) {
			this.registerForm.username = this.$route.query.username
			this.registerForm.password = this.$route.query.password
			this.registerForm.confirmPwd = this.$route.query.confirmPwd
			this.registerForm.verificationCode = this.$route.query.verificationCode
			this.checked = this.$route.query.checked === 'true'
		}
	},
	beforeDestroy () {
		clearInterval(this.timer)
	},
	methods: {
		goAgreement () {
			this.$router.push({ path: '/agreement', query: { username: this.registerForm.username, password: this.registerForm.password, confirmPwd: this.registerForm.confirmPwd, verificationCode: this.registerForm.verificationCode, checked: this.checked } })
		},
		tipsHandle (content, type, duration) {
			this.$message({
				message: content,
				type: type
			})
		},
		userHandle (bool) {
			this.userFocus = bool
			if (!bool && this.registerForm.username) {
				if (this.phoneReg.test(this.registerForm.username)) {
					this.verifyTel()
				} else {
					this.registerForm.username = ''
				}
			}
		},
		verifyTel () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlNVA}/verifytelfree/${this.registerForm.username}`
			}).then(res => {
				if (res.result) {
					this.repeatUsername = false
				} else {
					this.tipsHandle(`手机号码${this.registerForm.username}已经注册`, 'error')
					this.registerForm.username = ''
				}
			}).catch(() => {
				this.repeatUsername = true
				this.registerForm.username = ''
			})
		},
		pwdHandle (bool) {
			this.pwdFocus = bool
		},
		pwdShowHandle () {
			this.pwdShow = !this.pwdShow
		},
		confirmPwdHandle (bool) {
			this.confirmPwdFocus = bool
		},
		confirmPwdShowHandle () {
			this.confirmPwdShow = !this.confirmPwdShow
		},
		verifyHandle (bool) {
			this.verificationCodeFocus = bool
		},
		onKeyupInput () {
			inputAutoFocus.apply(this, [event, 'registerForm']).then(() => {
				console.log(123)
			})
		},
		getVerificationCode () {
			if (this.registerForm.username === '') {
				this.tipsHandle('请输入手机号码', 'error')
				return false
			}
			if (this.repeatUsername) {
				this.tipsHandle(`手机号码${this.registerForm.username}已经注册`, 'error')
				return false
			}
			this.verifyTime = 60
			if (this.phoneReg.test(this.registerForm.username)) {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlNVA}/registmsm/${this.registerForm.username}`
				}).then(res => {
					if (res.result) {
						this.tipsHandle('验证码已发送，请查收', 'success')
						this.verifyTimeShow = !this.verifyTimeShow
						this.timer = setInterval(() => {
							if (this.verifyTime === 0) {
								this.verifyTimeShow = !this.verifyTimeShow
								clearInterval(this.timer)
							}
							this.verifyTime--
						}, 1000)
					} else {
						this.tipsHandle('验证码发送失败，请重试', 'error')
					}
				})
			}
		},
		register () {
			if (!this.checked) {
				this.tipsHandle('请同意协议后再注册', 'error')
				return false
			}
			if (!this.registerForm.username) {
				this.tipsHandle('请输入手机号', 'error')
				return false
			}
			if (!this.registerForm.password) {
				this.tipsHandle('请输入密码', 'error')
				return false
			}
			if (!this.registerForm.confirmPwd) {
				this.tipsHandle('请确认密码', 'error')
				return false
			}
			if (!this.registerForm.verificationCode) {
				this.tipsHandle('请输入验证码', 'error')
				return false
			}
			if (this.registerForm.password.length < 6) {
				this.tipsHandle('密码不能小于6位', 'error')
				return false
			}
			if (!this.passwordReg.test(this.registerForm.password) || this.chinessReg.test(this.registerForm.password)) {
				this.tipsHandle('请填写字母和数字组合密码', 'error')
				return false
			}
			if (this.registerForm.password !== this.registerForm.confirmPwd) {
				return false
			}
			if (this.repeatUsername) {
				this.tipsHandle(`手机号码${this.registerForm.username}已经注册`, 'error')
				return false
			}
			var params = {
				tel: this.registerForm.username,
				password: this.registerForm.password,
				checkCode: this.registerForm.verificationCode,
				inviteCode: 'b123456'
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlNVA}/quickorder/regist`,
				data: params
			}).then(res => {
				this.tipsHandle('注册成功！', 'success')
				this.$router.push('/login')
			})
		},
		toLogin () {
			this.$router.push({
				path: '/login'
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.register-form-part {
	display flex
	flex-direction column
	align-items center
	padding-top 30px
	p {
		font-weight 700
		font-size 20px
		padding: 30px 0
	}
	.register-form {
		width: 350px
		.el-form-item {
			margin-bottom: 10px
		}
		.register-item {
			display flex
			flex-direction row
			align-items center
			border-bottom: 1px solid #7e8388
			/deep/ .el-input__inner {
				&::placeholder {
					color: #9fa2a5
					font: 100% tahoma, "\5B8B\4F53", arial;
				}
				&::-webkit-input-placeholder {
					color: #9fa2a5
					font: 100% tahoma, "\5B8B\4F53", arial;
				}
			}
			.register-input {
				width 290px
			}
			.verify-input {
				width 230px
			}
			.register-icon {
				display inline-block
				width 25px
				height 25px
			}
			.verify-time-button {
				width: 92px
			}
			.userFocus {
				background-image: url('~images/icon/user-active.png')
			}
			.userBlur {
				background-image: url('~images/icon/user.png')
			}
			.pwdFocus {
				background-image: url('~images/icon/pwd-active.png')
			}
			.pwdBlur {
				background-image: url('~images/icon/pwd.png')
			}
			.pwdShow {
				background-image: url('~images/icon/pwd-show.png')
			}
			.pwdHidden {
				background-image: url('~images/icon/pwd-hidden.png')
			}
			.verifyFocus {
				background-image: url('~images/icon/verify-active.png')
			}
			.verifyBlur {
				background-image: url('~images/icon/verify.png')
			}
		}
		.register-button {
			width: 350px
			margin 60px 0 10px
		}
		.agreement-box {
			display: flex
			justify-content: space-between
			align-items: center
			.el-checkbox {
				margin-right: 10px
			}
			.agreement {
				text-decoration underline
				color: var(--fx-primary-color)
				font-size: 14px
				cursor: pointer
			}
			.toLogin {
				text-decoration: underline
				cursor: pointer
			}
			.toLogin:hover {
				color: var(--fx-primary-color)
			}
		}
	}
	/deep/.el-input__inner {
		border: none
		background none
	}
	/deep/.el-form-item__content {
		line-height: 42px
    font-size: 14px
	}
}
</style>
